import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AsmAdapter } from '@spartacus/asm/core';
import { OccAsmAdapter } from '@spartacus/asm/occ';
import { AsmImpersonationAdapter } from '../../../asm-impersonation/connectors/asm-impersonation.adapter';
import { provideDefaultConfig } from '../../../config/config-providers';
import { defaultOccAsmConfig } from './default-occ-asm-config';
import { OccAsmImpersonationAdapter } from './occ-asm-impersonation.adapter';

@NgModule({
  imports: [CommonModule],
  providers: [
    provideDefaultConfig(defaultOccAsmConfig),
    {
      provide: AsmAdapter,
      useClass: OccAsmAdapter,
    },
    {
      provide: AsmImpersonationAdapter,
      useClass: OccAsmImpersonationAdapter,
    },
  ],
})
export class AsmOccModule {}
